import * as React from "react";
import { cx } from "../../utils/cx";
export function AccordionTableContent({ direction = "vertical", alignItems = "last baseline", justify = "start", children, }) {
    const isHorizontal = direction === "horizontal";
    return (React.createElement("div", { className: cx("flex gap-y-1", alignItems !== "last baseline" && "flex-wrap", alignItems === "last baseline" ? "gap-x-2" : "gap-x-3"), style: {
            flexDirection: isHorizontal ? "row" : "column",
            alignItems: isHorizontal ? alignItems : undefined,
            justifyContent: isHorizontal ? justify : undefined,
        } }, children));
}
const inlineStyleForAccordionTableContentSeparator = {
    borderStyle: "dotted",
    minWidth: "0.75rem",
    lineHeight: "70%", // a hack to make the separator line up with the text
};
export function AccordionTableContentSeparator() {
    return (React.createElement("div", { style: inlineStyleForAccordionTableContentSeparator, className: cx("mx-2 flex-1 min-w-[8px] grow border-0 border-separator border-b") }, "\u00A0"));
}
